module.exports = __webpack_public_path__ + "img/help.c7a769df.svg";